export default __webpack_public_path__ + "static/media/bill-list.ef75d01f.svg";